import {
  ActionIcon,
  Badge,
  Box,
  Button,
  FileButton,
  Flex,
  NumberFormatter,
  rem,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { useDebouncedState } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconDownload,
  IconEdit,
  IconFileDownload,
  IconPlus,
  IconTrash,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_Row,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import { NotificationExtension } from "../../../../../../_base/extension/NotificationExtension";
import { _localization } from "../../../../../../config/location";
import { tblItemByCat } from "../../../../../../model/TblItem";
import {
  tblPromotion,
  tblPromotionItemPrimaryCommand,
} from "../../../../../../model/TblPromotion";
import ModalItemPrimaryDiscountToAll from "../../Modals/ModalItemPrimaryDiscountToAll";
import ModalItemPrimaryEditDiscount from "../../Modals/ModalItemPrimaryEditDiscount";
import ModalSearchItems from "../../Modals/SearchItems";

const TableItemPrimaryPromotion = ({
  form,
  setDeleteData,
  typePromotion,
}: {
  form: UseFormReturnType<tblPromotion, (values: tblPromotion) => tblPromotion>;
  setDeleteData: any;
  typePromotion: string;
}) => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 25 });
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [data, setData] = useState<tblPromotionItemPrimaryCommand[]>([]);
  const [dataTemp, setDataTemp] = useState<tblPromotionItemPrimaryCommand[]>(
    [],
  );

  const entity: tblPromotionItemPrimaryCommand = {
    id: 0,
    promoteId: null,
    idItemPrimary: null,
    price: null,
    priceNotTakePromote: null,
    discountPercent: null,
    discountAmount: null,
    quantityNeededToBuyRule: null,
    amountNeededToBuyRule: null,
    quantityMin: null,
    quantityMax: null,
    attribute1: null,
    // attribute2: null,
    attribute3: null,
    // attribute4: null,
    // attribute5: null,
    // attribute6: null,
    // attribute7: null,
    // attribute8: null,
    // attribute9: null,
    // attribute10: null,
    // attribute11: null,
    // attribute12: null,
    // attribute13: null,
    // attribute14: null,
    // attribute15: null,
    itemPrimaryCode: null,
    itemPrimaryName: null,
  };

  const columns = React.useMemo<
    MRT_ColumnDef<tblPromotionItemPrimaryCommand>[]
  >(
    () => [
      //   {
      //     accessorKey: "apply",
      //     header: "Áp dụng cho",
      //     size: 20,
      //   },
      {
        accessorKey: "itemPrimaryCode",
        header: "Mã hàng",
        size: 100,
      },
      {
        accessorKey: "itemPrimaryName",
        header: "Tên hàng",
        size: 500,
        Cell: ({ renderedCellValue }) => (
          <Tooltip label={renderedCellValue as string}>
            <Text truncate="end">{renderedCellValue}</Text>
          </Tooltip>
        ),
      },
      {
        accessorKey: "discountPercent",
        header: "% chiết khấu",
        enableGlobalFilter: false,
        Cell: ({ renderedCellValue }) => `${renderedCellValue || 0} %`,
      },
      {
        accessorKey: "discountAmount",
        header: "Số tiền chiết khấu",
        enableGlobalFilter: false,
        Cell: ({ renderedCellValue }) => (
          <NumberFormatter
            value={(renderedCellValue as string | number) || 0}
            suffix="₫"
            thousandSeparator="."
            decimalSeparator=","
          />
        ),
      },
      {
        accessorKey: "price",
        header: "Giá tiền áp dụng trong CTKM",
        enableGlobalFilter: false,
        Cell: ({ renderedCellValue }) => (
          <NumberFormatter
            value={(renderedCellValue as string | number) || 0}
            suffix="₫"
            thousandSeparator="."
            decimalSeparator=","
          />
        ),
      },
      {
        accessorKey: "attribute3",
        header: "Số lượng áp dụng",
        enableGlobalFilter: false,
      },
      {
        accessorKey: "attribute1",
        header: "Số lượng đã bán",
        enableGlobalFilter: false,
      },
      {
        accessorKey: "quantityRemaining",
        header: "Số lượng còn lại",
        enableGlobalFilter: false,
        Cell: ({ row }) => (
          <Text size="11.5px" fw={500}>
            {Number(row.original.attribute3) - Number(row.original.attribute1)}
          </Text>
        ),
      },
      {
        accessorKey: "quantityMin",
        header: "SL tối thiểu 1 lần phải mua/1 Đ.Hàng",
        enableGlobalFilter: false,
      },
      {
        accessorKey: "quantityMax",
        header: "SLượng tối đa 1 lần được mua/1 Đ.Hàng",
        enableGlobalFilter: false,
      },
      {
        accessorKey: "attribute5",
        header: "Thứ tự hiển thị",
      },
      {
        accessorKey: "attribute4",
        header: "Nổi bật",
        Cell: ({ renderedCellValue }) => (
          <Badge color={renderedCellValue === "Y" ? "green" : "gray"}>
            {renderedCellValue === "Y" ? "Nổi bật" : "Không nổi bật"}
          </Badge>
        ),
      },
      {
        accessorKey: "attribute6",
        header: "Hãng/NCC tài trợ",
        enableGlobalFilter: false,
        Cell: ({ renderedCellValue }) => (
          <NumberFormatter
            value={(renderedCellValue as string | number) || 0}
            suffix="₫"
            thousandSeparator="."
            decimalSeparator=","
          />
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableColumnActions: false,
        enableGlobalFilter: false,
        enableSorting: false,
        size: 100,
        Cell: ({ renderedCellValue, row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {processTaskActionMenu(row)}
          </Box>
        ),
      },
    ],
    [typePromotion],
  );

  function processTaskActionMenu(
    row: MRT_Row<tblPromotionItemPrimaryCommand>,
  ): any {
    return (
      <>
        <Tooltip label="Sửa chiết khấu">
          <ActionIcon
            variant="light"
            aria-label="Settings"
            color="yellow"
            onClick={() => openModalItemPrimaryEditDiscount(row.original)}
          >
            <IconEdit size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
        {/* <Tooltip label="Xem chi tiết chiết khấu">
          <ActionIcon variant="light" aria-label="Settings" color="cyan">
            <IconEye
              size={14}
              stroke={1.5}
              //   onClick={}
            />
          </ActionIcon>
        </Tooltip> */}
        <Tooltip label="Xóa sản phẩm">
          <ActionIcon
            variant="light"
            aria-label="Settings"
            color="red"
            onClick={() => deletesData([row.original.itemPrimaryCode ?? ""])}
          >
            <IconTrash size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
      </>
    );
  }

  const getColumnVisibility = () => {
    if (typePromotion && typePromotion !== "1") {
      return {
        id: false,
        discountPercent: false,
        attribute5: true,
      };
    } else {
      return {
        id: false,
        discountPercent: true,
        attribute5: false,
      };
    }
  };

  const filterDuplicateItems = (dataArray: any) => {
    const seen = new Set();

    return dataArray.filter((item: any) => {
      // Kiểm tra nếu itemPrimaryCode đã tồn tại
      if (seen.has(item.itemPrimaryCode)) {
        return false; // Bỏ qua item trùng
      }

      // Thêm itemPrimaryCode vào Set và giữ lại item này
      seen.add(item.itemPrimaryCode);
      return true;
    });
  };

  const openSearchItems = () => {
    modals.openConfirmModal({
      size: "90vw",
      centered: true,
      title: <Title order={5}>Tìm kiếm mặt hàng</Title>,
      children: <ModalSearchItems handleAddSearchItem={handleAddSearchItem} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const openModalItemPrimaryDiscountToAll = () => {
    modals.openConfirmModal({
      size: 1100,
      title: <Title order={5}>Nhập chiết khấu</Title>,
      children: (
        <ModalItemPrimaryDiscountToAll
          appleDiscountToAll={appleDiscountToAll}
          itemType="primary"
          typePromotion={typePromotion}
          dataProps={
            table.getSelectedRowModel().rows.map((row) => row.original)
              .length === 0
              ? data
              : table.getSelectedRowModel().rows.map((row) => row.original)
          }
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const openModalItemPrimaryEditDiscount = (
    dataEdit: tblPromotionItemPrimaryCommand,
  ) => {
    modals.openConfirmModal({
      size: "600",
      title: <Title order={5}>Nhập chiết khấu</Title>,
      children: (
        <ModalItemPrimaryEditDiscount
          dataEdit={dataEdit}
          editItemDiscount={editItemDiscount}
          typePromotion={typePromotion}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleAddSearchItem = (selectItem: tblItemByCat[]) => {
    const newData: tblPromotionItemPrimaryCommand[] = selectItem?.map(
      (item, index) => ({
        ...entity,
        idItemPrimary: item.itemId,
        itemPrimaryCode: item.itemCode,
        itemPrimaryName: item.itemName,
        quantityMin: 1,
        attribute1: "0",
        attribute4: "N",
        price: 0,
        attribute5: String(index + 1),
        attribute6: "0",
      }),
    );

    const addUniqueItems = (prevData: tblPromotionItemPrimaryCommand[]) => {
      const uniqueItemsMap = new Map<string, tblPromotionItemPrimaryCommand>();

      [...newData, ...prevData].forEach((item) => {
        if (item.itemPrimaryCode) {
          uniqueItemsMap.set(item.itemPrimaryCode, item);
        }
      });
      return Array.from(uniqueItemsMap.values());
    };

    setData((prevData) => addUniqueItems(prevData));
    setDataTemp((prevData) => addUniqueItems(prevData));
    setRowCount((prevData) => prevData + selectItem.length);
    setSelectIds([]);
    table.resetRowSelection();
    modals.closeAll();
  };

  const appleDiscountToAll = (
    dataSubmit: {
      discountPercent: null;
      discountAmount: null;
      quantityMin: null;
      quantityMax: null;
    },
    dataAtt5: any[],
  ) => {
    const select = table.getSelectedRowModel().rows.map((row) => row.original);

    if (select.length > 0) {
      setDataTemp((prevData) =>
        prevData.map((item) => {
          const selectedItem = select.find(
            (selected) => selected.itemPrimaryCode === item.itemPrimaryCode,
          );

          if (selectedItem) {
            // Tìm item tương ứng trong dataAtt5
            const att5Item = dataAtt5.find(
              (att5) => att5.itemPrimaryCode === item.itemPrimaryCode,
            );

            return {
              ...item,
              ...dataSubmit,
              // Thêm attribute5 nếu tìm thấy trong dataAtt5
              ...(att5Item && { attribute5: att5Item.attribute5 }),
            };
          }
          return item;
        }),
      );

      setData((prevData) =>
        prevData.map((item) => {
          const selectedItem = select.find(
            (selected) => selected.itemPrimaryCode === item.itemPrimaryCode,
          );

          if (selectedItem) {
            // Tìm item tương ứng trong dataAtt5
            const att5Item = dataAtt5.find(
              (att5) => att5.itemPrimaryCode === item.itemPrimaryCode,
            );

            return {
              ...item,
              ...dataSubmit,
              // Thêm attribute5 nếu tìm thấy trong dataAtt5
              ...(att5Item && { attribute5: att5Item.attribute5 }),
            };
          }
          return item;
        }),
      );
    } else {
      setDataTemp((prevData) =>
        prevData.map((item) => {
          // Tìm item tương ứng trong dataAtt5
          const att5Item = dataAtt5.find(
            (att5) => att5.itemPrimaryCode === item.itemPrimaryCode,
          );

          return {
            ...item,
            ...dataSubmit,
            // Thêm attribute5 nếu tìm thấy trong dataAtt5
            ...(att5Item && { attribute5: att5Item.attribute5 }),
          };
        }),
      );

      setData((prevData) =>
        prevData.map((item) => {
          // Tìm item tương ứng trong dataAtt5
          const att5Item = dataAtt5.find(
            (att5) => att5.itemPrimaryCode === item.itemPrimaryCode,
          );

          return {
            ...item,
            ...dataSubmit,
            // Thêm attribute5 nếu tìm thấy trong dataAtt5
            ...(att5Item && { attribute5: att5Item.attribute5 }),
          };
        }),
      );
    }

    modals.closeAll();
    table.resetRowSelection();
  };

  const editItemDiscount = (dataSubmit: tblPromotionItemPrimaryCommand) => {
    setDataTemp((prevData) =>
      prevData.map((item) =>
        item.itemPrimaryCode === dataSubmit.itemPrimaryCode ? dataSubmit : item,
      ),
    );
    setData((prevData) =>
      prevData.map((item) =>
        item.itemPrimaryCode === dataSubmit.itemPrimaryCode ? dataSubmit : item,
      ),
    );

    modals.closeAll();
  };

  const deletesData = (ids: string[]) => {
    setDataTemp((prevData) =>
      prevData.filter(
        (item) => !ids.includes(item?.itemPrimaryCode?.toString() || ""),
      ),
    );
    setData((prevData) =>
      prevData.filter(
        (item) => !ids.includes(item?.itemPrimaryCode?.toString() || ""),
      ),
    );

    setSelectIds([]);
    table.resetRowSelection();
  };

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (465 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    form.setFieldValue("tblPromotionItemPrimaryCommands", dataTemp);
  }, [dataTemp]);

  const [file, setFile] = useState<File | null>(null);
  const resetRef = useRef<() => void>(null);

  // Hàm xử lý file Excel
  const handleFileUpload = (file: File) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      const binaryData = event.target?.result;
      const workbook = XLSX.read(binaryData, { type: "binary" });

      // Lấy sheet đầu tiên
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json<any>(sheet);
      const mappedData: tblPromotionItemPrimaryCommand[] = jsonData.map(
        (row: any, index: number) => ({
          id: index + 1, // Giả định ID tự động tăng
          promoteId: null,
          idItemPrimary: null,
          price: row["Giá tiền áp dụng trong CTKM"] || null,
          priceNotTakePromote: null,
          discountPercent: row["%chiết khấu"] || null,
          discountAmount: row["Số tiền chiết khấu"] || null,
          quantityNeededToBuyRule: null,
          amountNeededToBuyRule: null,
          quantityMin: row["SL tối thiếu"] || null,
          quantityMax: row["SL tối đa"] || null,
          itemPrimaryCode: row["Mã hàng"] || null,
          itemPrimaryName: row["Tên hàng"] || null,
          attribute3: row["Số lượng áp dụng"] || null,
          attribute1: row["Số lượng đã bán"] || null,
          attribute4: row["Nổi bật"] || null,
          attribute5: row["Thứ tự hiển thị"] || null,
          attribute6: row["Hãng/NCC tài trợ"] || null,
        }),
      );

      setDataTemp((x) => filterDuplicateItems([...mappedData, ...x]));
      setData((x) => filterDuplicateItems([...mappedData, ...x]));
      setRowCount(mappedData.length);
      setFile(null);
    };

    reader.readAsBinaryString(file);
  };

  const inputRef = useRef(null);

  const table = useMantineReactTable<tblPromotionItemPrimaryCommand>({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    renderTopToolbarCustomActions: ({ table }) => (
      <div ref={headerRef}>
        <Flex
          gap="md"
          justify="flex-start"
          align="center"
          direction="row"
          wrap="wrap"
        >
          <Box>
            {/* <Flex gap="md">
              <TextInput
                placeholder="Nhập từ khoá"
                ref={inputRef}
                onChange={(e) => {
                  handleSearch(e.target.value);
                }}
              />
            </Flex> */}
          </Box>
          {/* <Button
            leftSection={<IconSearch size={14} />}
            color="blue"
            variant="outline"
            onClick={async () => {
              // await fetchData();
            }}
          >
            Lọc bảng giá
          </Button> */}
        </Flex>
      </div>
    ),
    renderToolbarInternalActions: ({ table }) => (
      <>
        <Flex
          gap="md"
          justify={"flex-end"}
          align="center"
          direction="row"
          wrap="wrap"
        >
          <FileButton
            resetRef={resetRef}
            onChange={(file) => {
              if (
                file &&
                (file.type ===
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                  file.type === "application/vnd.ms-excel")
              ) {
                handleFileUpload(file);
              } else
                NotificationExtension.Fails(
                  "File không đúng định đạng Excel !",
                );
              resetRef.current?.();
            }}
          >
            {(props) => (
              <Button
                leftSection={
                  <IconFileDownload
                    style={{ width: rem(14), height: rem(14) }}
                  />
                }
                {...props}
              >
                Import Excel
              </Button>
            )}
          </FileButton>

          <Button
            leftSection={<IconDownload size={14} />}
            color="teal"
            variant="outline"
            component="a" // Dùng thẻ <a> thay cho <button>
            href="/template/TemplateUploadSTKMSPC.xlsx" // Đường dẫn đến file trong thư mục public
            download // Thuộc tính tải file
          >
            Tải file mẫu
          </Button>

          <Button
            leftSection={<IconPlus size={14} />}
            color="blue"
            variant="outline"
            onClick={openSearchItems}
          >
            Thêm mới (F11)
          </Button>

          <Button
            leftSection={<IconTrash size={14} />}
            color="red"
            variant="outline"
            onClick={() => {
              const ids = table
                .getSelectedRowModel()
                .rows.map((row) => row.original.itemPrimaryCode ?? "");
              deletesData(ids ?? []);
            }}
            //   disabled={selectIds.length < 1}
          >
            Xóa (đã chọn)
          </Button>

          <Button
            leftSection={<IconEdit size={14} />}
            color="green"
            variant="outline"
            disabled={data.length === 0}
            onClick={() => openModalItemPrimaryDiscountToAll()}
          >
            Thiết lập chiết khấu
          </Button>

          {/* <Menu shadow="md">
            <Menu.Target>
              <Button
                rightSection={
                  <IconCaretDown style={{ width: rem(14), height: rem(14) }} />
                }
              >
                Chức năng
              </Button>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Label>Dữ liệu</Menu.Label>
              <Tooltip label="Chức năng đang cạp nhật">
                <Menu.Item
                  leftSection={
                    <IconFileUpload
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                >
                  Import Excel
                </Menu.Item>
              </Tooltip>
            </Menu.Dropdown>
          </Menu> */}
        </Flex>
      </>
    ),
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    // enableRowVirtualization: false,
    enableBatchRowSelection: true,
    enablePagination: true,
    selectAllMode: "all",
    // rowVirtualizerOptions: { overscan: 8 },
    getRowId: (row) => row?.itemPrimaryCode?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: [
          "mrt-row-select",
          "apply",
          "itemPrimaryCode",
          "namePurchase",
          "nameManufacturer",
        ],
        right: ["allocationRate", "action"],
      },
      columnVisibility: { id: false },
      density: "xs",
      showGlobalFilter: true,
    },
    enableGlobalFilter: true,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    // manualFiltering: true,
    // manualPagination: true,
    // manualSorting: true,
    // rowCount,
    // onColumnFiltersChange: setColumnFilters,
    // onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        //  fontWeight: row.getIsSelected() ? "bold" : "normal", //conditional styling
        // fontWeight: "bold",
        fontSize: "11px",
        padding: "4px 12px",
      },
    }),
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      // showProgressBars: isRefetching,
      // showSkeletons: isLoading, //loading for the first time with no data
      //   sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  React.useEffect(() => {
    const newColumnVisibility = getColumnVisibility();
    if (table) {
      table.setColumnVisibility(newColumnVisibility);
    }
  }, [typePromotion, table]);

  return <MantineReactTable table={table} />;
};

export default TableItemPrimaryPromotion;
